//frontend/src/App.js
import React from "react";
import ChatBot from "./components/ChatBot";
import "./App.css";

function App() {
  return (
    
      <ChatBot />
    
  );
}

export default App;
